export interface CaseStudyEntry {
  label: string;
  url?: string;
}

const extractFileName = (path?: string) => {
  if (!path) return "Case study";
  const cleanPath = path.split("?")[0];
  return cleanPath.split("/").pop() || path;
};

const addEntryFromValue = (value: any, entries: CaseStudyEntry[]) => {
  if (!value) return;

  if (typeof value === "string") {
    entries.push({
      label: extractFileName(value),
      url: value,
    });
    return;
  }

  if (typeof value === "object") {
    const possibleUrl = value?.url || value?.caseStudyUrl || value?.link;
    const label =
      value?.fileName ||
      value?.name ||
      extractFileName(typeof possibleUrl === "string" ? possibleUrl : undefined);

    entries.push({
      label,
      url: possibleUrl,
    });
  }
};

export const buildCaseStudyEntries = (ticketData: any) => {
  const entries: CaseStudyEntry[] = [];
  if (!ticketData) {
    return {
      entries,
      isCaseStudyUploaded: false,
    };
  }

  const caseStudyArrayCandidates = [
    ticketData?.caseStudies,
    ticketData?.case_studies,
    ticketData?.caseStudyFiles,
    ticketData?.caseStudy,
  ].filter((value): value is any[] => Array.isArray(value));

  const caseStudyObjectCandidates = [ticketData?.caseStudy, ticketData?.caseStudyFiles].filter(
    (value: any) =>
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      Object.keys(value).length > 0
  );

  const caseStudyStringCandidates = [
    ticketData?.caseStudyUrl,
    ticketData?.caseStudy?.caseStudyUrl,
    ticketData?.caseStudyFiles?.caseStudyUrl,
    ticketData?.caseStudy_link,
  ].filter((value): value is string => typeof value === "string" && value.trim().length > 0);

  caseStudyArrayCandidates.forEach((arr) => arr.forEach((item) => addEntryFromValue(item, entries)));
  caseStudyObjectCandidates.forEach((obj) => addEntryFromValue(obj, entries));
  caseStudyStringCandidates.forEach((str) => addEntryFromValue(str, entries));

  return {
    entries,
    isCaseStudyUploaded: entries.length > 0,
  };
};

